import axios from "../axios-orders";
import {
  CategoryType,
  OpportunityItem,
  Page,
  OpportunityCounts,
  CategoryFilterResponse,
} from "../types";

export const listOpportunities = async (
  type: CategoryType,
  page = 0,
  size = 10,
  categoryFilters?: string[]
): Promise<Page<OpportunityItem>> => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });

  if (categoryFilters?.length) {
    params.append("categoryFilters", categoryFilters.join(","));
  }

  const path = `/api/opportunities/${type.toLowerCase().replace("_", "-")}`;
  const { data } = await axios.get(`${path}?${params.toString()}`);
  return data;
};

export const getFilters = async (
  type: CategoryType,
  all = false
): Promise<CategoryFilterResponse[]> => {
  const base = all
    ? "/api/opportunities/filters/all"
    : "/api/opportunities/filters";
  const { data } = await axios.get(`${base}/${type}`);
  return data;
};

export const getCounts = async (): Promise<OpportunityCounts> => {
  const { data } = await axios.get("/api/opportunities/counts");
  return data;
};
